export default function SvgRefresh() {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          cursor="pointer"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M13 2l-2 1.995.06.06M11 18l2 1.91-.03.032M11.06 4.055L13 6m-1.94-1.945A8 8 0 0117 18.245M7 5.755a8 8 0 005.97 14.187M11 22l1.97-2.058"
          ></path>
        </svg>
      </>
    );
  }
  